import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

const Button = styled.div`
  background: white;
  box-sizing: border-box;
  border-radius: 6px;
  color: ${themeGet('colors.primary.100')} !important;
  display: flex;
  justify-content: space-evenly;
  align-items: baseline;

  &:hover {
    background: white !important;
  }
`;

const ButtonText = styled.span`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 24px;
  pointer-events: none;
`;

const renderData = rawData =>
  Object.keys(rawData).reduce((result, data) => {
    const insertData = {};
    const key = `data-${data
      .split(/(?=[A-Z])/)
      .join('-')
      .toLowerCase()}`;
    insertData[key] = rawData[data];
    return Object.assign(insertData, result);
  }, {});

const buttonContent = props => {
  if (props.faIcon) {
    return <i className={`${props.faIcon}`} />;
  }

  return <ButtonText>{props.buttonText}</ButtonText>;
};

export const ClientAdminButtonComponent = props => (
  <li className={props.liClass} {...renderData(props.liData || {})}>
    <Button
      className={props.aClass}
      onClick={e => {
        e.stopPropagation();
        props.onClickAction(e);
      }}
      {...renderData(props.aData || {})}
    >
      {buttonContent(props)}
      {props.spanText ? <ButtonText>{props.spanText}</ButtonText> : null}
    </Button>
  </li>
);

ClientAdminButtonComponent.propTypes = {
  liClass: PropTypes.string,
  liData: PropTypes.object,
  aClass: PropTypes.string,
  onClickAction: PropTypes.func,
  aData: PropTypes.object,
  faIcon: PropTypes.string,
  buttonText: PropTypes.string,
  spanText: PropTypes.string,
};
